import { render, staticRenderFns } from "./DoughnutPieChart.vue?vue&type=template&id=cfa13a94&scoped=true&"
import script from "./DoughnutPieChart.vue?vue&type=script&lang=ts&"
export * from "./DoughnutPieChart.vue?vue&type=script&lang=ts&"
import style0 from "./DoughnutPieChart.vue?vue&type=style&index=0&id=cfa13a94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa13a94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
